export default __webpack_public_path__ + "fb2fadff6ac65d619d986c0a3e98e7c8.png";